import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';


export interface DialogData {
  title: string;
  abheftordnung: string;
  doi: string;
}


@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {

  constructor(
    public router: Router,
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit() {
    console.log(this.data);

    this.data.doi = this.data.doi.replace('http://dx.doi.org/', '');
    // this.data.doi = replace
  }

  link(id) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/document/' + id]));
      this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


}
